import { render } from "./SurveyCardWrapper.vue?vue&type=template&id=50827e8d&scoped=true"
import script from "./SurveyCardWrapper.vue?vue&type=script&lang=js"
export * from "./SurveyCardWrapper.vue?vue&type=script&lang=js"

import "./SurveyCardWrapper.vue?vue&type=style&index=0&id=50827e8d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50827e8d"]])

export default __exports__